import { _ as _slicedToArray } from '../slicedToArray-DvtHmgP0.js';
import { useState } from 'react';
import { BreakPoints } from '../enums/index.js';
import IS_BROWSER from '../isBrowser/index.js';
import useMount from '../useMount/index.js';

// don't use without discussion

var getBreakPoint = function getBreakPoint(width) {
  if (Number(BreakPoints.ExtraLarge) >= width && Number(BreakPoints.Large) < width) return Number(BreakPoints.Large);
  if (Number(BreakPoints.Large) >= width && Number(BreakPoints.Medium) < width) return Number(BreakPoints.Medium);
  if (Number(BreakPoints.Medium) >= width && Number(BreakPoints.Small) < width) return Number(BreakPoints.Small);
  if (Number(BreakPoints.Small) >= width) return Number(BreakPoints.Small);
  return Number(BreakPoints.ExtraLarge);
};
var useBreakPoint = function useBreakPoint() {
  var _useState = useState(getBreakPoint(IS_BROWSER ? window.innerWidth : 0)),
    _useState2 = _slicedToArray(_useState, 2),
    breakPoint = _useState2[0],
    setBreakPoint = _useState2[1];
  useMount(function () {
    var handleResize = function handleResize() {
      return setBreakPoint(getBreakPoint(window.innerWidth));
    };
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  });
  return breakPoint;
};

export { useBreakPoint as default };
//# sourceMappingURL=index.js.map
